/* eslint-disable react-refresh/only-export-components --
 * ルータ定義ファイル。RootLayout を別ファイルへ移しても router の export は残るため
 * 警告は消えず、Fast Refresh もルート編集時はどのみちフルリロードになる。
 * unizo/web の router.tsx と同じ扱い (PRODUCT_DEV-629)。
 */
import { createBrowserRouter, Outlet } from "react-router";
import { rootLoader } from "@/loaders/root-loader";
import UniQApp from "@/pages/UniQApp";
import SurveyAdminList from "@/pages/admin/SurveyAdminList";
import SurveyBuilder from "@/pages/admin/SurveyBuilder";
import SurveyResults from "@/pages/admin/SurveyResults";
import SurveyAssign from "@/pages/admin/SurveyAssign";

const basename = import.meta.env.BASE_URL.replace(/\/+$/, "") || "/";

function RootLayout() {
  return (
    <div style={{ position: "relative", minHeight: "100vh" }}>
      <Outlet />
    </div>
  );
}

export const router = createBrowserRouter(
  [
    {
      path: "/",
      id: "root",
      loader: rootLoader,
      element: <RootLayout />,
      children: [
        { index: true, element: <UniQApp /> },
        { path: "admin", element: <SurveyAdminList /> },
        { path: "admin/new", element: <SurveyBuilder /> },
        { path: "admin/:surveyId/edit", element: <SurveyBuilder /> },
        { path: "admin/:surveyId/results", element: <SurveyResults /> },
        { path: "admin/:surveyId/assign", element: <SurveyAssign /> },
      ],
    },
  ],
  { basename },
);
